import { ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type {
  IConsultantLocatorNameRequest,
  IConsultantLocatorKnowAllRequest,
  IConsultantLocatorZipCodeRequest,
  IConsultantLocatorResponse
} from '@/types/LocatorTypes.ts'

export async function GetLocatorConsultantList(
  request: IConsultantLocatorNameRequest
): Promise<IConsultantLocatorResponse> {
  const url = await GetOrderEntryConnectorUrl('ConsultantLocatorKnowGetList')
  return await ApiPost(url, request)
}

export async function GetLocatorConsultantListByZip(
  request: IConsultantLocatorZipCodeRequest
): Promise<IConsultantLocatorResponse> {
  const url = await GetOrderEntryConnectorUrl('ConsultantLocatorMapGetList')
  return await ApiPost(url, request)
}

export async function GetLocatorConsultantKnowAllList(
  request: IConsultantLocatorKnowAllRequest
): Promise<IConsultantLocatorResponse> {
  const url = await GetOrderEntryConnectorUrl('ConsultantLocatorKnowAllGetList')
  return await ApiPost(url, request)
}
